import React, { Fragment, useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useWindowSize } from 'react-use';
import cn from 'classnames';
import {
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  // Fab,
} from '@material-ui/core';
import { anketsStore, attachmentsStore } from 'stores';
import { Description as DescriptionIcon } from '@material-ui/icons';
import { ru } from 'locale';
import { formatDate, fullDateShortTimeFormat } from 'utils/date';
import { Page, EmptyState, ScreenLoader } from 'components';
import useStyles from './AttachmentsScreen.styles';

const bottomNavigationHeight = 56;

const AttachmentsScreen = observer(() => {
  const classes = useStyles();
  const { fetchState, files } = attachmentsStore;
  const { height: windowHeight } = useWindowSize();
  const pageHeight = windowHeight - bottomNavigationHeight;
  const hasFiles = files.length !== 0;

  useEffect(
    () =>
      autorun(() => {
        attachmentsStore.getFiles(anketsStore.anketId);
      }),
    [],
  );

  // const handleFileAdd = () => {};

  const renderFiles = () => {
    if (!hasFiles) {
      return <EmptyState title={ru.noFiles} />;
    }

    return (
      <div className={classes.list}>
        <List component="nav" classes={{ root: classes.listInner }} aria-label={ru.attachments}>
          {files.map(file => {
            const date = formatDate(file.created, fullDateShortTimeFormat);

            return (
              <Fragment key={file.id}>
                <ListItem
                  button
                  component={Link}
                  href={file.fileUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <ListItemIcon>
                    <DescriptionIcon />
                  </ListItemIcon>
                  <ListItemText primary={file.fileName} secondary={`${file.author} | ${date}`} />
                </ListItem>

                <Divider />
              </Fragment>
            );
          })}
        </List>
      </div>
    );
  };

  // const renderFileUploader = () => {
  //   return (
  //     <>
  //       <Fab
  //         color="secondary"
  //         aria-label="add"
  //         className={classes.addButton}
  //         onClick={handleFileAdd}
  //       >
  //         <AddIcon />
  //       </Fab>
  //     </>
  //   );
  // };

  return (
    // <Page style={{ minHeight: '100rvh' }}>
    <Page style={{ height: pageHeight }}>
      <Grid container direction="column" className={classes.list}>
        {fetchState === 'pending' && <ScreenLoader />}

        <Grid
          container
          item
          direction="column"
          justify={hasFiles ? 'flex-start' : 'center'}
          className={cn({
            [classes.content]: !hasFiles,
            [classes.listInner]: true,
          })}
        >
          {fetchState === 'fulfilled' && renderFiles()}
        </Grid>
      </Grid>

      {/* {renderFileUploader()} */}
    </Page>
  );
});

export default AttachmentsScreen;
